import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiUserLight, PiBuildingLight, PiCurrencyDollarLight, PiClockLight, PiMapPinLight } from 'react-icons/pi';
import Badge from '../shared/TailwindComponents/Badge';
import { formatDate, getStatusColor } from '../../utils/functions';
import { BadgeColor } from '../shared/TailwindComponents/types/badgeTypes';

interface LeadGridItemProps {
  lead: any;
  onClick: () => void;
}

const LeadGridItem: React.FC<LeadGridItemProps> = ({ lead, onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      className="glass relative cursor-pointer rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex flex-col gap-3"
    >
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-bold text-gray-900 dark:text-white">{lead.case_name}</h3>
        <Badge color={getStatusColor(lead.status) as BadgeColor}>{t(lead.status)}</Badge>
      </div>

      <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        {lead.client_type === 'Individual' ? <PiUserLight /> : <PiBuildingLight />}
        <span>{lead.client_name}</span>
        <span>•</span>
        <span>{lead.case_type}</span>
      </div>

      <p className="text-sm text-gray-600 dark:text-gray-400 line-clamp-2">{lead.case_description}</p>

      <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
        <div className="flex items-center gap-1">
          <PiMapPinLight />
          <span>{lead.case_location}</span>
        </div>
        <div className="flex items-center gap-1">
          <PiCurrencyDollarLight />
          <span>{`$${lead.budget}`}</span>
        </div>
      </div>

      <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
        <div className="flex items-center gap-1">
          <PiClockLight />
          <span>{lead.timeframe}</span>
        </div>
        <span>{formatDate(lead.created_at)}</span>
      </div>
    </div>
  );
};

export default LeadGridItem;